"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isVR360Property = exports.vr360PropertyDefinition = void 0;
exports.vr360PropertyDefinition = {
    view: {
        label: 'VR 360',
        style: 'video-essence',
    },
    constraints: [
        {
            name: 'required',
            argument: true,
        },
        {
            name: 'providers',
            argument: [
                'Media Partnerships Video',
                'RBMN 360',
                'RBMN Video',
            ],
        },
    ],
    type: 'service',
    multiple: false,
    name: 'vr-360',
};
const isVR360Property = (prop) => {
    return prop.name === exports.vr360PropertyDefinition.name;
};
exports.isVR360Property = isVR360Property;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidnItMzYwLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvdnItMzYwLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsdUJBQXVCLEdBQUc7SUFDckMsSUFBSSxFQUFFO1FBQ0osS0FBSyxFQUFFLFFBQVE7UUFDZixLQUFLLEVBQUUsZUFBZTtLQUN2QjtJQUNELFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFVBQVU7WUFDaEIsUUFBUSxFQUFFLElBQUk7U0FDZjtRQUNEO1lBQ0UsSUFBSSxFQUFFLFdBQVc7WUFDakIsUUFBUSxFQUFFO2dCQUNSLDBCQUEwQjtnQkFDMUIsVUFBVTtnQkFDVixZQUFZO2FBQ2I7U0FDRjtLQUNGO0lBQ0QsSUFBSSxFQUFFLFNBQVM7SUFDZixRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSxRQUFRO0NBQ2lCLENBQUE7QUFJMUIsTUFBTSxlQUFlLEdBQUcsQ0FBQyxJQUFrQixFQUF5QixFQUFFO0lBQzNFLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSywrQkFBdUIsQ0FBQyxJQUFJLENBQUE7QUFDbkQsQ0FBQyxDQUFBO0FBRlksUUFBQSxlQUFlLG1CQUUzQiJ9